import styled from 'styled-components';
import { Tag } from 'antd';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #fff;
  margin-bottom: 8px;
`;
// Layout styled components
export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px - 26px - 80px);
`;

export const ChartContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px 24px 16px;

  .header {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    color: rgb(0 0 0 / 100%);
    height: 28px;
  }

  .dimension-filter {
    .gm-ant-collapse-header {
      padding: 0;
    }

    .gm-ant-collapse-content-box {
      padding: 0;
    }
  }
`;

export const FilterRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  border-radius: 2px;
  border: 1px solid #d9d9d9;

  .label {
    background-color: #f5f5f5;
    padding: 4px 8px;
  }

  .number-input {
    flex: 1;
    border: none;
    background-color: transparent;
  }
`;

export const SelectContainer = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

export const SelectedEventsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 32px;
`;

export const SelectedEventTag = styled(Tag)`
  margin: 0;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  color: #1890ff;
  cursor: default;
`;

export const LeftPanel = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: #fff;
  height: 100%;
`;
export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 3px;
`;
export const PanelHeader = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  color: rgb(0 0 0 / 100%);
  height: 60px;
  padding: 0 24px;
  padding-right: 34px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(0 0 0 / 15%);
  background-color: #fff;

  .description {
    font-weight: 300;
    color: rgb(0 0 0 / 45%);
  }

  .title {
    margin-right: 12px;
  }
`;

export const PanelHeaderForLeft = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  color: rgb(0 0 0 / 100%);
  min-height: 60px;
  padding: 0 24px;
  padding-right: 34px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgb(0 0 0 / 15%);
  background-color: #fff;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 99;
`;
export const TopBarOfPatterns = styled.div`
  padding: 8px;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const BusinessGoal = styled.span`
  padding: 4px 8px;
  display: inline-block;
  background-color: #f2f6ff;
  border-radius: 4px;
  border: 1px solid #b3c8ff;
  color: #0046ff;
  font-weight: normal;
`;

export const ChartContentContainer = styled.div`
  background: #fff;
  height: calc(100vh - 220px);
  overflow: auto;
`;
export const FloatPanel = styled.div`
  position: sticky;
  margin-left: 14px;
  background-color: #fff;
  padding: 10px;
  z-index: 100;
  max-width: 100%;
  display: flex;
  align-items: center;

  .title {
    font-size: 16px;
    font-weight: 300;
    color: rgb(0 0 0 / 45%);
    margin-right: 12px;
  }
`;
